var FieldUpdater = new function()
{
	this.Fields = new function()
	{
	};
	this.NextId = 0;
	this.UpdateInterval = SystemParms.AnalysisInterval * 1000;
	this.UpdateCount = 0;
	this.ParamStrings = new function()
	{
	};
	this.UpdateListeners = new Array();

	this.RequestUpdate = function()
	{
		var CurrentRequest = '';

		for (i in this.ParamStrings)
		{
			var Cell = this.Fields[i].Cell;
			var Update = true;

			var Inputs = GetInputs(Cell);
			for ( var j = 0; j < Inputs.length; j++)
			{
				if (Inputs[j].Focus || hasClass(Inputs[j], 'Modified'))
				{
					Update = false;
					break;
				}
			}

			if (Update)
			{
				if (CurrentRequest == '')
				{
					CurrentRequest = this.ParamStrings[i];
				}
				else if (CurrentRequest.length + this.ParamStrings[i].length >= 2048)
				{
					HTTPRequest('/UpdateFields.php', 'POST', CurrentRequest, FieldUpdater, 'Update');
					this.UpdateCount++;
					CurrentRequest = this.ParamStrings[i];
				}
				else
				{
					var NewRequest = CurrentRequest + '&' + this.ParamStrings[i];
					CurrentRequest = NewRequest;
				}
			}
		}

		if (CurrentRequest != '')
		{
			HTTPRequest('/UpdateFields.php', 'POST', CurrentRequest, FieldUpdater, 'Update');
			this.UpdateCount++;
		}
		else
		{
			this.StartUpdates();
		}
	};

	this.Update = function(http_request)
	{
		if ((http_request.readyState == 4) && (http_request.status == 200))
		{
			try
			{
				var Data = eval('(' + http_request.responseText + ')');
			}
			catch (e)
			{
				OverrideSaveCheck = true;
				document.write(http_request.responseText);
				return;
			}

			if (IsString(Data))
			{
				if (Data == 'Session Timeout')
				{
					LogOff(Data);
				}
				else
				{
					OverrideSaveCheck = true;
					document.write(http_request.responseText);
				}
				return;
			}

			for ( var i in Data)
			{
				if (this.Fields[i])
				{
					this.Fields[i].Update(Data[i]);
				}

				Data[i] = null;
			}

			for ( var i = 0; i < this.UpdateListeners.length; i++)
			{
				this.UpdateListeners[i].Object[this.UpdateListeners[i].Callback]();
			}

			Data = null;

			this.UpdateCount--;
			this.StartUpdates();
		}
	};

	this.StartUpdates = function()
	{
		if ((this.UpdateInterval > 0) &&(this.UpdateCount == 0))
		{
			setTimeout("FieldUpdater.RequestUpdate ();", this.UpdateInterval);
		}
	};

	this.Register = function(Field)
	{
		for (i in this.Fields)
			if ((this.Fields[i].Id == Field.Id) && (this.Fields[i].TableName == Field.TableName) && (this.Fields[i].ColumnName == Field.ColumnName))
			{
				Field.FieldId = i;
				break;
			}

		if (Field.FieldId == -1)
		{
			Field.FieldId = ++this.NextId;
		}

		this.ParamStrings[Field.FieldId] = 'FI[]=' + Field.FieldId + '&I[]=' + Field.Id + '&RO[]=' + (Field.ReadOnly ? '1' : '0') + '&TN[]=' + Field.TableName
				+ '&CN[]=' + Field.ColumnName;
		this.Fields[Field.FieldId] = Field;
	};

	this.Unregister = function(Field)
	{
		delete (this.ParamStrings[Field.FieldId]);
		delete (this.Fields[Field.FieldId]);
	};

	this.AddListener = function(Object, CallbackName)
	{
		var Listener = new function()
		{
		};
		Listener.Object = Object;
		Listener.Callback = CallbackName;

		this.UpdateListeners.push(Listener);
	};
};

function UpdateField(DataCell)
{
	this.FieldId = -1;

	this.ReadOnly = DataCell.getAttribute('ReadOnly') == '1';
	this.TableName = DataCell.getAttribute('TableName');
	this.ColumnName = DataCell.getAttribute('ColumnName');

	var Row = DataCell.parentNode;
	if (this.TableName == 'Image')
	{
		this.Id = Row.getAttribute('ImageIds');
	}
	else
	{
		this.Id = Row.getAttribute('Ids');
	}

	this.Cell = DataCell;
	this.Update = function(Contents)
	{
		while (this.Cell.lastChild)
		{
			this.Cell.removeChild(this.Cell.lastChild);
		}

		this.Cell.innerHTML = Contents;
	};

	// Note: the parent function "UpdateField" is only loaded in the Case Details, and thus only registered there
	this.Register = function()
	{
		FieldUpdater.Register(this);
	};

	this.Unregister = function()
	{
		FieldUpdater.Unregister(this);
	};
}
